import { Button } from 'antd';
import { useEffect, useState } from 'react';

import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import style from './StripeS7Modules.module.css';
import { Unit } from '../../../Models/PlatformManager/Unit';
import RenderCard from '../RenderCard';
import { serviceBundler } from '../../../App';

import { S7Module } from '../../../Models/PlatformManager/S7Module';
import { AddS7ModuleForm } from '../../../Pages/PlatformManager/forms/AddS7ModuleForm/AddS7ModuleForm';

const StripeS7Modules = (props: {
  unit: Unit;
  setModule: Function;
  modules?: S7Module[];
}) => {
  const [s7Module, setS7Module] = useState<S7Module>();
  const [s7Modules, setS7Modules] = useState<Array<S7Module>>();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModelEditMode, setModelEditMode] = useState(false);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setS7Modules(props.modules);
  }, [props]);

  const FilterModules = (items: S7Module[]) => {
    return items.filter((x) => x.idUnit == props.unit.id);
  };

  const NavContentUnit = (item: S7Module) => {
    setS7Module(item);
    props.setModule(item.id);
  };

  const IsItemActive = (item: S7Module) => {
    if (s7Module?.name == item.name) {
      return true;
    }
    return false;
  };

  const handleCancelForm = () => {
    setIsModalOpen(false);
  };

  const OpenModelAddUnit = () => {
    props.setModule(undefined);
    setS7Module(new S7Module());
    setModelEditMode(false);
    setIsModalOpen(true);
  };

  const OpenModelEditUnit = (item: S7Module) => {
    setS7Module(item);
    setModelEditMode(true);
    setIsModalOpen(true);
  };

  const SafeS7Module = async (item: S7Module) => {
    setIsModalOpen(false);

    var result = Array<S7Module>();
    if (item.id !== undefined) {
      result = await serviceBundler.platformService.UpdateS7Module(item);
    } else {
      result = await serviceBundler.platformService.AddS7Module(
        props.unit,
        item,
      );
    }

    setS7Modules(FilterModules(result));
  };

  const RemoveS7Module = async (item: S7Module) => {
    setIsModalOpen(false);

    setS7Module(undefined);
    setS7Modules(
      FilterModules(
        await serviceBundler.platformService.DeleteS7Module(props.unit, item),
      ),
    );
  };

  return (
    <>
      <div className={style.scrollFor}>
        {s7Modules?.map((item: S7Module, i) =>
          RenderCard(
            true,
            item,
            item.id,
            item.name,
            IsItemActive(item),
            NavContentUnit,
            OpenModelEditUnit,
          ),
        )}
      </div>

      <AddS7ModuleForm
        allData={s7Modules}
        data={s7Module}
        open={isModalOpen}
        onEdit={isModelEditMode}
        onCancel={handleCancelForm}
        onSafe={SafeS7Module}
        onRemove={RemoveS7Module}
      ></AddS7ModuleForm>
      <div className={style.btnPos}>
        <Button onClick={OpenModelAddUnit} icon={<PlusCircleOutlined />}>
          {t('adds7module')}
        </Button>
      </div>
    </>
  );
};

export default StripeS7Modules;
